





















































import { computed, defineComponent, onMounted, ref } from '@nuxtjs/composition-api';
import ProductStyleLabel from '~/components/pages/Product/ProductStyleLabel.vue';
import { useProductParams } from '~/composables/product/useProductParams';
import { useStore } from '~/composables/useStore';
import { PRODUCT_COLOR_ID, STYLE_INFO_LIST, PRODUCT_WINE_COLOR_LABELS } from '~/constants';

export default defineComponent({
  components: {
    ProductStyleLabel,
  },
  props: {
    productColorId: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const store = useStore();
    const { pickColorValue } = useProductParams();

    const currentColorId = ref('');

    const onClickColorButton = (id: string) => {
      currentColorId.value = id;
    };

    onMounted(() => {
      if (props.productColorId) {
        currentColorId.value = pickColorValue([props.productColorId])[0];
        return;
      }
      currentColorId.value = pickColorValue(store.state.product.filter.colors)[0] ?? PRODUCT_COLOR_ID.RED;
    });

    const currentStyles = computed(
      () => STYLE_INFO_LIST.find(({ colorId }) => colorId === currentColorId.value)?.styles || []
    );
    const currentColorLabel = computed(
      () => PRODUCT_WINE_COLOR_LABELS.find(({ id }) => id === currentColorId.value)?.label || ''
    );

    return {
      PRODUCT_WINE_COLOR_LABELS,
      STYLE_INFO_LIST,
      currentColorId,
      onClickColorButton,
      currentStyles,
      currentColorLabel,
    };
  },
});
